import React from "react";
import { connect } from "react-redux";
import { ProgressBar, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { onPressReferralsDropDown } from "../../actions";
import { Link } from "react-router-dom";
import axios from "axios";

class ReferralsCard extends React.Component {
  state = {
    totalReferrals: 0,
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchReferralsCount();
  }
  fetchReferralsCount = async () => {
    this.setState({ loading: true });
  
    let page = 1;
    const pageSize = 100; // Adjust page size if needed
    let totalPages = 1;
    let totalReferrals = 0;
  
    try {
      while (page <= totalPages) {
        const response = await axios.get(`https://samaj.aasmo.in/api/admin/users?page=${page}&size=${pageSize}`);
  
        // Log the API response for debugging
        console.log(`API Response for page ${page}:`, response.data);
  
        const { status, data } = response.data;
  
        if (status === 'success' && data?.users) {
          // Sum up the referral counts for the current page
          const referralsPageTotal = data.users.reduce((sum, user) => sum + (user.referralCount || 0), 0);
          totalReferrals += referralsPageTotal;
  
          totalPages = data.totalPages || 1; // Update totalPages from the response
          page += 1; // Move to the next page
        } else {
          console.error("Unexpected API response format:", response.data);
          this.setState({ totalReferrals: 0, loading: false, error: "Unexpected API response format" });
          return;
        }
      }
  
      // Update state with the total referrals count
      this.setState({ totalReferrals, loading: false });
    } catch (error) {
      console.error("Error fetching referrals:", error);
      this.setState({ totalReferrals: 0, loading: false, error: "Error fetching data" });
    }
  };
  
  
  

  
  
  
  

  render() {
    const { totalReferrals, loading, error } = this.state;
    const { onPressReferralsDropDown } = this.props;

    return (
      <div className="card">
        <div className="header">
          <h2>Referrals</h2>
          {/* <Dropdown as="ul" className="header-dropdown">
            <Dropdown.Toggle
              variant="success"
              as="li"
              id="dropdown-basic"
              onClick={onPressReferralsDropDown}
            >
              Options
            </Dropdown.Toggle>
            <Dropdown.Menu
              as="ul"
              className="dropdown-menu dropdown-menu-right"
            >
              <li>
                <Link to="#">Action</Link>
              </li>
              <li>
                <Link to="#">Another Action</Link>
              </li>
              <li>
                <Link to="#">Something else</Link>
              </li>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
        <div className="body">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : (
            <ul className="list-unstyled list-referrals">
              <li>
                <p>
                  <span className="value">Total referrals:</span>
                  <span className="text-muted float-right">
                    {totalReferrals}
                  </span>
                </p>
                <ProgressBar
                  className="progress progress-xs progress-transparent custom-color-blue"
                  now={totalReferrals} // Adjust this based on your requirements
                  // min={0}
                  // max={100}
                />
              </li>
            </ul>
          )}
        </div>
      </div>
    );
  }
}

ReferralsCard.propTypes = {
  onPressReferralsDropDown: PropTypes.func.isRequired,
};

const mapStateToProps = ({ analyticalReducer }) => ({
  referralsDropDown: analyticalReducer.referralsDropDown,
});

export default connect(mapStateToProps, {
  onPressReferralsDropDown,
})(ReferralsCard);
